export default __webpack_public_path__ + "btn-save2.png?5f478551c0b05e7df1ec0b9618ec0fef";